import _ from 'lodash'
import Select from 'components/Select'
import { useTranslate } from 'hooks/translate'
import Styled from './styled'
export default function FilterPeriodicitySelect({ defaultValue, onChange = () => null }) {
  const { t } = useTranslate()
  const options = _.map(
    [
      {
        name: 'Weekly',
        id: 'weekly',
      },
      {
        name: 'Monthly',
        id: 'monthly',
      },
      {
        name: 'Quarterly',
        id: 'quarterly',
      },
      {
        name: 'Yearly',
        id: 'yearly',
      },
    ],
    (period) => {
      return {
        label: period?.name,
        value: period?.id,
      }
    }
  )
  return (
    <Styled className="filter-profile-select-component">
      <Select
        allowClear={false}
        showSearch={false}
        value={defaultValue}
        dropdownMatchSelectWidth={false}
        options={options}
        placeholder={t('Period')}
        onChange={onChange}
      />
    </Styled>
  )
}
